import React from "react";
import "./StatusBackground.scss"; 

const StatusBackground = ({ status }) => {
  const getStatusClass = (status) => {
    switch (status) {
    case "New Task":
        return "to-do";
    case "In Progress":
        return "in-progress";
    case "Completed":
        return "completed";
    case "Approved":
        return "Approved";
      case "Active":
        return "active";
    case "Ongoing":
        return "Ongoing";
    case "approved":
        return "Approved";
    case "pending":
       return "Pending";
    case "Closed":
        return "Closed";
    case "Rejected":
        return "Rejected";
      default:
        return "default";
    }
  };

  return (
    <>
      {status ? <div className={`status-background ${getStatusClass(status)}`}>
        {status}
      </div> : <></>}
    </>
  );
};

export default StatusBackground;